import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { MagicLinkForm } from '../components/MagicLinkForm';
import { isSafeReturnTo } from '../lib/return_to';

const ERROR_MESSAGES: Record<string, string> = {
  invalid_link: 'That sign-in link has expired or is invalid. Please request a new one.',
  network: 'A network error occurred while verifying your link. Please try again.',
};

export function SignIn() {
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  // Read error code passed via navigate state from SignInConsume.
  const redirectError = (location.state as { error?: string } | null)?.error ?? null;
  // Optional same-origin return path (e.g. the /book wizard hands off here
  // with its draft id). Anything that isn't root-relative falls back to /account.
  const returnTo = params.get('returnTo');
  const callbackURL = isSafeReturnTo(returnTo) ? returnTo : '/account';

  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1.5rem',
        background: 'var(--background, #fafaf7)',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '380px',
          background: 'white',
          padding: '2rem 1.75rem',
          borderRadius: '14px',
          boxShadow: 'inset 0 0 0 1px var(--border, oklch(0.9 0.005 80))',
        }}
      >
        <h1
          style={{
            fontSize: '1.4rem',
            fontWeight: 500,
            marginBottom: '0.25rem',
            letterSpacing: '-0.01em',
          }}
        >
          Sign in
        </h1>
        <p
          style={{
            color: 'var(--muted-foreground, #6b6b6b)',
            fontSize: '0.875rem',
            marginBottom: redirectError ? '1rem' : '1.5rem',
          }}
        >
          We'll email you a link to sign in.
        </p>
        {redirectError && (
          <p
            role="alert"
            style={{
              color: 'var(--destructive, oklch(0.55 0.16 28))',
              fontSize: '0.85rem',
              marginBottom: '1.25rem',
              padding: '0.65rem 0.75rem',
              borderRadius: '8px',
              background: 'oklch(0.97 0.02 28)',
              border: '1px solid oklch(0.88 0.04 28)',
            }}
          >
            {ERROR_MESSAGES[redirectError] ??
              'Something went wrong with your sign-in link. Please request a new one.'}
          </p>
        )}
        <MagicLinkForm
          callbackURL={callbackURL}
          onSent={(email) => navigate('/sign-in/sent', { state: { email } })}
        />
      </div>
    </main>
  );
}
